import { createContext, ReactNode, useContext, useEffect, useMemo } from 'react';
import usePersistedState from '../hooks/usePersistedState';
import { TutorialType } from '../types/enums';
import { useAuth } from './auth';

type ProviderProps = {
  children: ReactNode;
};

type ContextProps = {
  tutorialProgress: TutorialType[];
  setTutorialProgress: (tutorialProgress: TutorialType[]) => void;
};

export const TutorialProgressContext = createContext({} as ContextProps);

export function TutorialProgressProvider({ children }: ProviderProps) {
  const [tutorialProgress, setTutorialProgress] = usePersistedState<TutorialType[]>(
    'tutorialProgress',
    [],
    true,
  );
  const { user } = useAuth();
  const contextValues = useMemo(
    () => ({
      tutorialProgress,
      setTutorialProgress,
    }),
    [setTutorialProgress, tutorialProgress],
  );

  useEffect(() => {
    if (user?.tutorialProgress?.length) {
      setTutorialProgress([
        ...(tutorialProgress?.filter((t) => !user.tutorialProgress.includes(t)) ?? []),
        ...user.tutorialProgress,
      ]);
    }
  }, [setTutorialProgress, tutorialProgress, user?.tutorialProgress]);
  return (
    <TutorialProgressContext.Provider value={contextValues}>
      {children}
    </TutorialProgressContext.Provider>
  );
}
export const useTutorialProgress = () => useContext(TutorialProgressContext);
export default TutorialProgressProvider;
